import React from 'react';
import { Gift, ChevronRight } from 'lucide-react';

interface GiftSectionProps {
  onStartClick: () => void;
}

const GiftSection: React.FC<GiftSectionProps> = ({ onStartClick }) => {
  return (
    <section className="py-8 md:py-20 bg-gradient-to-b from-rose-50/50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-16 h-16 bg-rose-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <Gift size={32} className="text-rose-500" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-semibold text-stone-900 mb-4">
            Regala la conversación que nunca habéis tenido
          </h2>
          <p className="text-lg text-stone-600 mb-8 max-w-xl mx-auto">
            Regala Ethernal y recibirán preguntas que abren conversaciones que nunca habéis tenido. Todo lo que descubráis queda guardado: su voz, sus fotos, su forma de hablar.
          </p>
          <button
            onClick={onStartClick}
            className="bg-rose-500 text-white px-8 py-3.5 rounded-full text-base font-semibold hover:bg-rose-600 transition shadow-lg hover:shadow-rose-500/30 inline-flex items-center gap-2"
          >
            Regalar Ethernal
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default GiftSection;
